import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import s from "./styles.scss";

export const ImagePreview = ({ dataUri, index, _delete }) => {
  return (
    <div
      width="200px"
      height="150px"
      style={{ position: "relative", margin: "5px" }}
    >
      <img src={dataUri} width="200px" height="150px" />
      <span
        className={`${s.btnDeleteCorner}`}
        onClick={() => {
          if (!!_delete) {
            _delete(index);
          }
        }}
      >
        <FontAwesomeIcon icon={faTrash} color="#fff" />
      </span>
    </div>
  );
};

export default ImagePreview;
